import { IQuickActionUser } from "@common/microservice-types/db/quick-action/quick-action.user";
import { TQuickActionTag } from "@common/microservice-types/db/quick-action/quick-action.default";
import { BehaviorSubject, Observable } from "rxjs";

export class ChatQuickActionStore
{
    private readonly quickActions$ = new BehaviorSubject<IQuickActionUser[]>([]);
    private storedActions: IQuickActionUser[] = [];

    constructor(
        private readonly persistActions: (actions: IQuickActionUser[]) => void,
        private readonly tag: string,
    ) { }

    public $getQuickActions(): Observable<IQuickActionUser[]>
    {
        return this.quickActions$.asObservable();
    }

    public getStoredActions(): IQuickActionUser[]
    {
        return [ ...this.storedActions ];
    }

    public setQuickActions(actions: IQuickActionUser[]): IQuickActionUser[]
    {
        return this.setStoredActions(actions);
    }

    public setStoredActions(actions: IQuickActionUser[], persist = true): IQuickActionUser[]
    {
        this.storedActions = [ ...actions ];
        this.publishActions();

        if (persist)
        {
            this.persistActions(this.storedActions);
        }

        return this.quickActions$.getValue();
    }

    private publishActions(): void
    {
        // Keep element identity (no per-item clone) so a reference held by the
        // component survives an Object.assign after create/update resolves.
        this.quickActions$.next(
            this.storedActions
                .filter(item => !item.tag?.length || item.tag.includes(this.tag as TQuickActionTag) || item.tag.includes('global')),
        );
    }
}
